module.exports = __webpack_public_path__ + "static/media/circledivided2.f0a0977d.svg";